<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtext1"><a id="page_1"><span class="bolditalic">‘The world is your studio. Never let anything remain unsketched.’</span></a></p><a id="page_1">
<p class="fmtext1a"><span class="bold">Adebanji Alade</span></p>
<div class="tspace">
<div class="img_container"><img alt="image" src="images/img-001.jpg"/></div>
</div>
</a><div class="pbreak"><a id="page_1">
<div class="tspace">
<div class="img_container"><img alt="image" src="images/img-002.jpg"/></div>
</div>
<p class="fmauth"><span class="ornb">ADEBANJI ALADE,</span> otherwise known as ‘The Addictive Sketcher’, features regularly on the BBC’s <em class="italic">The One Show</em>, and can often be found sketching travellers on the London Underground.</p>
<p class="fmtext-in">He trained at Yaba College of Technology in Nigeria, later obtaining a diploma in portraiture from Heatherley’s School of Fine Art in Chelsea, where he now teaches. Adebanji is the vice president of the Royal Institute of Oil Painters; a full member of The Guild of Fine Art in Nigeria; and in 2014 was elected to the council of the Chelsea Art Society. He also belongs to Urban Sketchers Worldwide and Plein Air Brotherhood.</p>
<p class="fmtext-in">His awards include Buxton Spa Sketchbook Award (2014); winner of Pinta Rapido Plein Air Event at Chelsea Town Hall in 2013; winner of Best Painting of a London Scene, Chelsea Art Society in 2010; the Alan Gourley Memorial Award at the Royal Institute of Oil Painters Exhibition 2017, and numerous others.</p>
<p class="fmtext-in">Adebanji has a strong following in the US as well as the UK. He writes regularly for <em class="italic">The Artist</em> magazine and exhibits with the Royal Institute of Oil Painters. He teaches at the Art Academy, London, and also runs workshops and demos for schools, colleges, universities and art societies.</p>
<p class="fmtext-in">Follow Adebanji online:</p>
</a><p class="fmtext"><a id="page_1">Website: </a><a href="http://www.adebanjialade.co.uk" target="_blank">www.adebanjialade.co.uk</a></p>
<p class="fmtext">instagram: @addictivesketcher</p>
<p class="fmtext">Facebook page: <a href="http://facebook.com/addictivesketcher" target="_blank">facebook.com/addictivesketcher</a></p>
<div class="pbreak">
<div class="img_container"><a id="page_2"><img alt="image" src="images/img-003.jpg"/></a></div><a id="page_2">
</a></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Author.vue?c21cfea0